import Vue from 'vue'

import SupplierTemplateSelect from './views/supplier/SupplierTemplateSelect'
import SupplierConfig from './views/supplier/SupplierConfig'
import SupplierSelect from './views/supplier/SupplierSelect'
import GroupSupplierSelect from './components/GroupSupplierSelect'
import GroupViewSelect from './components/GroupViewSelect'
import AgentSelect from './views/agent/AgentSelect'
import ClientSelect from './views/agent/ClientSelect'
import OperatorSelect from './components/OperatorSelect'
import PackageItemTypeSelect from './components/PackageItemTypeSelect'
import PackageItemSelect from './components/PackageItemSelect'
import PackagesSelect from './components/PackagesSelect'
import PackageSelect from './components/PackageSelect'
import PackageTypeSelect from './components/PackageTypeSelect'
import TrafficUnitSelect from './components/TrafficUnitSelect'
import VoiceUnitSelect from './components/VoiceUnitSelect'
import MessageUnitSelect from './components/MessageUnitSelect'
import ConnectionUnitSelect from './components/ConnectionUnitSelect'
import PackageDurationSelect from './components/PackageDurationSelect'
import WechatAppSelect from './components/WechatAppSelect'
import CardKindSelect from './components/CardKindSelect'
import RangeInput from './components/RangeInput'
import BatchSelect from './views/card/BatchSelect'
import GroupBatchSelect from './views/group/BatchSelect'
import StateSelect from './components/StateSelect'
import StatusSelect from './components/StatusSelect'
import OrderStatusSelect from './components/OrderStatusSelect'
import CertificationSelect from './components/CertificationSelect'
import WithdrawalsSelect from './components/WithdrawalsSelect'
import ApprovalSelect from './components/ApprovalSelect'
import VirtualPercentInput from './components/VirtualPercentInput'
import TrueOrFalseSelect from './components/TrueOrFalseSelect'
import ProgressStatusSelect from './components/ProgressStatusSelect'
import MonthSelect from './components/MonthSelect'
import CardLogTypeSelect from './components/CardLogTypeSelect'
import DateTimePicker from './components/DateTimePicker'
import PackageTransfer from './components/PackageTransfer'
import PackageThroughStatusSelect from './components/PackageThroughStatusSelect'
import CycleSelect from './components/CycleSelect'
import UserOrderTypeSelect from './components/UserOrderTypeSelect'
import CardStatusSelect from './components/CardStatusSelect'
import OrderStateSelect from './components/OrderStateSelect'
import WayBillStatusSelect from './components/WayBillStatusSelect'
import WayBillCompanySelect from './components/WayBillCompanySelect'
import PublicSelect from './components/PublicSelect'
import OperatorRadio from './components/OperatorRadio'
import RoleSelect from '@/views/auth/RoleSelect'
import ClientMethodSelect from './components/ClientMethodSelect'
import ClientModeSelect from './components/ClientModeSelect'
import Description from './components/Description'
import ProductSelect from './components/ProductSelect'
import UserSelect from './components/UserSelect'
import CardGroupSelect from './components/CardGroupSelect'
import TrafficGBInput from './components/TrafficGBInput'
import ActiveLogTypeSelect from './components/ActiveLogTypeSelect'
import AgentAccountSelect from './views/agent/AgentAccountSelect'
import MarginInput from './components/MarginInput'
import PublicInput from './components/PublicInput'
import HappeningSelect from './components/HappeningSelect'
import HappeningTransfer from './components/HappeningTransfer'
import ClientChargeSelect from './components/ClientChargeSelect'
import WechatPaySelect from './components/WechatPaySelect.vue'
import GroupSalesChannelSelect from './components/GroupSalesChannelSelect.vue'
import LogisticsCodeSelect from './components/WayBillStatusSelect.vue'
import AgentTransfer from './components/AgentTransfer'
import TableView2 from '@/components/TableView2'
import PasswordStrength from '@/components/PasswordStrength'
import AgentTableSelect from './components/AgentTableSelect'
import PackageTableSelect from './components/PackageTableSelect'
import CardGiftSelect from './components/CardGiftSelect.vue'
import ProductCategorySelect from './components/ProductCategorySelect'
import CardTypeSelect from './components/CardTypeSelect'
import WechatCardProductImg from './components/WechatCardProductImg'
import SupplierStatusSelect from './components/SupplierStatusSelect.vue'

Vue.component('agent-table-select', AgentTableSelect)
Vue.component('package-table-select', PackageTableSelect)
Vue.component('password-strength', PasswordStrength)
Vue.component('table-view2', TableView2)
Vue.component('supplier-template-select', SupplierTemplateSelect)
Vue.component('supplier-config', SupplierConfig)
Vue.component('supplier-select', SupplierSelect)
Vue.component('group-supplier-select', GroupSupplierSelect)
Vue.component('group-view-select', GroupViewSelect)
Vue.component('agent-select', AgentSelect)
Vue.component('client-select', ClientSelect)
Vue.component('operator-select', OperatorSelect)
Vue.component('package-item-type-select', PackageItemTypeSelect)
Vue.component('package-item-select', PackageItemSelect)
Vue.component('packages-select', PackagesSelect)
Vue.component('package-select', PackageSelect)
Vue.component('package-type-select', PackageTypeSelect)
Vue.component('traffic-unit-select', TrafficUnitSelect)
Vue.component('voice-unit-select', VoiceUnitSelect)
Vue.component('message-unit-select', MessageUnitSelect)
Vue.component('connection-unit-select', ConnectionUnitSelect)
Vue.component('package-duration-select', PackageDurationSelect)
Vue.component('wechat-app-select', WechatAppSelect)
Vue.component('card-kind-select', CardKindSelect)
Vue.component('range-input', RangeInput)
Vue.component('batch-select', BatchSelect)
Vue.component('group-batch-select', GroupBatchSelect)
Vue.component('state-select', StateSelect)
Vue.component('status-select', StatusSelect)
Vue.component('order-status-select', OrderStatusSelect)
Vue.component('certification-select', CertificationSelect)
Vue.component('withdrawals-select', WithdrawalsSelect)
Vue.component('approval-select', ApprovalSelect)
Vue.component('virtual-percent-input', VirtualPercentInput)
Vue.component('true-false-select', TrueOrFalseSelect)
Vue.component('progress-status-select', ProgressStatusSelect)
Vue.component('month-select', MonthSelect)
Vue.component('date-time-picker', DateTimePicker)
Vue.component('card-log-type-select', CardLogTypeSelect)
Vue.component('package-transfer', PackageTransfer)
Vue.component('package-through-status-select', PackageThroughStatusSelect)
Vue.component('cycle-select', CycleSelect)
Vue.component('user-order-type-select', UserOrderTypeSelect)
Vue.component('card-status-select', CardStatusSelect)
Vue.component('order-state-select', OrderStateSelect)
Vue.component('waybill-status-select', WayBillStatusSelect)
Vue.component('waybill-company-select', WayBillCompanySelect)
Vue.component('public-select', PublicSelect)
Vue.component('Operator-radio', OperatorRadio)
Vue.component('role-select', RoleSelect)
Vue.component('client-method-select', ClientMethodSelect)
Vue.component('client-mode-select', ClientModeSelect)
Vue.component('DescriptionList', Description)
Vue.component('product-select', ProductSelect)
Vue.component('user-select', UserSelect)
Vue.component('card-group-select', CardGroupSelect)
Vue.component('traffic-gb-input', TrafficGBInput)
Vue.component('active-log-type-select', ActiveLogTypeSelect)
Vue.component('agent-account-select', AgentAccountSelect)
Vue.component('margin-input', MarginInput)
Vue.component('public-input', PublicInput)
Vue.component('happening-select', HappeningSelect)
Vue.component('happening-transfer', HappeningTransfer)
Vue.component('client-charge-select', ClientChargeSelect)
Vue.component('logistics-code-select', LogisticsCodeSelect)
Vue.component('wechat-pay-select', WechatPaySelect)
Vue.component('group-sales-channel-select', GroupSalesChannelSelect)
Vue.component('agent-transfer-select', AgentTransfer)
Vue.component('card-gift-select', CardGiftSelect)
Vue.component('product-category-select', ProductCategorySelect)
Vue.component('card-type-select', CardTypeSelect)
Vue.component('wechat-card-product-img', WechatCardProductImg)
Vue.component('supplier-status-select', SupplierStatusSelect)



// WEBPACK FOOTER //
// ./src/card/init.js